import { BulkResizeState } from "../../../types";
import { getFlipOperation } from "../../../utils/operations/getFlipOperation";

interface IPayload {
    payload: {
        imageId: string;
    };
}

export const toggleHorizontal = (state: BulkResizeState, { payload: { imageId } }: IPayload) => {
    const image = state.images.find((image) => image.id === imageId);
    if (!image) throw new Error("image not found");
    image.flip.horizontal = !image.flip.horizontal;
    image.operations.push(getFlipOperation(image, "horizontal"));
};
